{
  "app_notification_title": "Вас пригласили оставить обратную связь для кандидата",
  "avg_score": "Средняя оценка",
  "change_answers": "Изменить ответы",
  "completed": "Завершённые",
  "create_new_motivation_description": "Сделайте интервью понятнее — и для команды, и для вас\nОпределите, что важно для этой роли, и помогите сосредоточиться на главном",
  "create_new_motivation_title": "Добавьте первую форму оценки",
  "create_scorecard": "Создать форму обратной связи",
  "deleted": "Удалённые",
  "duplicate_scorecard": "Дублировать форму",
  "duplicate_scorecard_confirm": "Будет создана копия формы обратной связи в виде черновика.",
  "error_select_at_least_one_participant": "Пожалуйста, выберите хотя бы одного участника",
  "feedback": "Обратная связь",
  "feedback_sent": "Обратная связь о кандидате {candidate_name} отправлена",
  "feedbacks": "Обратная связь",
  "has_feedback": "Есть обратная связь",
  "invitation_resent": "Приглашение было отправлено",
  "invitations_sent": "Приглашения были отправлены",
  "manage_forms": "Управление формами",
  "manage_scorecards": "Управление формами оценки",
  "notification_settings_feedbacks": "Новые запросы или результаты обратной связи",
  "request_feedback": "Запросить обратную связь",
  "resend_invite": "Отправить приглашение повторно",
  "return_to_candidate": "Перейти к кандидату",
  "return_to_candidates": "Перейти к списку кандидатов",
  "scorecard": "Форма обратной связи",
  "scorecards": "Формы обратной связи",
  "search_forms": "Поиск по формам",
  "show_profile": "Показать профиль {applicant}",
  "submit_your_response": "Ответить",
  "view_feedback": "Посмотреть результаты",
  "~": "~"
}
